import * as React from 'react';
var SvgStopperTearRounded = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.79 4.8c.424-1.067 1.996-1.067 2.42 0l3.456 8.69C17.916 16.63 15.502 20 12 20c-3.5 0-5.916-3.37-4.666-6.51L10.79 4.8Z"
}));
export default SvgStopperTearRounded;